import PropTypes from 'prop-types';
import React from 'react'
import RadioGroup from 'react-radio-group'

import SelectionItem from './TemplateParts/SelectionItem'


export default class extends React.Component {
    static propTypes = {
		options: PropTypes.object.isRequired,
		input_name: PropTypes.string.isRequired,
		nowOrGoal: PropTypes.oneOf(['now','goal']).isRequired,
		default_now: PropTypes.string,
		default_goal: PropTypes.string,
		now_field: PropTypes.string.isRequired,
		goal_field: PropTypes.string.isRequired,
		changeData: PropTypes.func.isRequired,
		prevSlide: PropTypes.func.isRequired,
		nextSlide: PropTypes.func.isRequired
	};

    state = {
        default_goal: this.props.default_goal,
        default_now: this.props.default_now,
        completed: this.props['default_' + this.props.nowOrGoal] != ''
    };

    changeData = (value) => {

		var field = this.props.nowOrGoal,
			stateData = this.state;

		stateData[ 'default_' + field ] = value
		stateData.completed = !!value;
		this.setState(stateData)

		var data = {};
		data[ this.props[field + '_field'] ] = value
		this.props.changeData({}, data)

	};

    render() {

		return (

			<div>
				<div className="slide-wrapper">
					<header className="bg-deep-main p20">
						<h4 className="text-white text-center mtop0 mbot0" dangerouslySetInnerHTML={{__html: this.props.title}}></h4>
					</header>
					<div className="inner bg-mid-main bg-slightly-transparent">
						<div className="vertical-selection colour-scheme-blue">

							{ this.props.options.map(option => {
								return <SelectionItem 
											key={'option-'+option.slug}
											input_name={this.props.input_name}
											value={option.slug}
											text={option.label}
											nowOrGoal={ this.props.nowOrGoal }
											selected_now={this.state.default_now}
											selected_goal={this.state.default_goal}
											changeData={this.changeData} />
							}) }

						</div>
					</div>
					<footer className="bg-deep-main p20">
						<p className="lead mbot0 text-center text-white">
							<i className="icon icon-chevron-left pull-left clickable" onClick={this.props.prevSlide}></i>
							<i className={"icon icon-chevron-right pull-right clickable " + (!this.state.completed ? "text-dark-gray" : "")}
								onClick={this.state.completed ? this.props.nextSlide : false}></i>
						</p>
						<div className="clearfix"></div>
					</footer>

				</div>

			</div>

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationParts/DoubleSelectTemplate.jsx